import React, { useState, useEffect } from "react";
import styles from "../../../views/ReportView/ReportView.module.css";
import "./IncomeAndExpense.css";
import IconAnimation from "../../iconAnimation/iconAnimation";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import Swal from "sweetalert2";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { HiClipboardDocumentList } from "react-icons/hi2";
import { FaArrowRight } from "react-icons/fa";

const IncomeAndExpenses = ({ data }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(data);
  const [seeList, setSeeList] = useState(false);
  const [incomeAndExpenseList, setIncomeAndExpenseList] = useState([]);
  const [incomeAndExpenseTotal, setIncomeAndExpenseTotal] = useState([]);
  const [reloadData, setReloadData] = useState(false);
  const [objincomeAndExpenses, setObjIncomeAndExpenses] = useState({
    incomeAndExpenses: "",
    createAt: "",
    description: "",
    amount: "",
    userId: user && user.id ? user.id : "1",
  });

  const viewList = () => {
    setSeeList(true);
  };

  const cancelviewList = () => {
    setSeeList(false);
  };

  const reloadChildData = () => {
    setReloadData((prevReloadData) => !prevReloadData);
  };

  const handlerCreate = async (e) => {
    e.preventDefault();
    const endpoint = `${process.env.REACT_APP_INCOME_AND_EXPENSES}`;
    const isIncome = objincomeAndExpenses.incomeAndExpenses === "Ingresos";
    try {
      const res = await axios.post(endpoint, {
        objincomeAndExpenses,
      });
      const successMessage = isIncome
        ? "Se creó el ingreso con éxito"
        : "Se creó el egreso con éxito";

      if (res.status === 201) {
        Swal.fire({
          icon: "success",
          title: "Exito",
          text: successMessage,
        });
      }
      reloadChildData();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Parece que hubo un error al tratar de llenar el Formulario",
      });
    }
  };

  const resetForm = () => {
    setUser(data);
    setObjIncomeAndExpenses({
      incomeAndExpenses: "",
      createAt: "",
      description: "",
      amount: "",
      userId: user && user.id ? user.id : "1",
    });
  };

  const handleClick = (e) => {
    e.preventDefault();
    handlerCreate(e);
    resetForm();
  };

  useEffect(() => {
    // Verificar si user tiene un valor definido
    if (user) {
      const userId = user.id;
      const apiUrl = `${process.env.REACT_APP_INCOME_AND_EXPENSES}?userId=${userId}`;

      const fetchData = async () => {
        try {
          const response = await axios.get(apiUrl);
          // Verificar si la respuesta es un 404 (No hay ingresos y egresos)
          if (response.status === 204) {
            // Actualizar el estado de ingresos y egresos a un arreglo vacío
            setIncomeAndExpenseList([]);
            setIncomeAndExpenseTotal([]);
          } else {
            setIncomeAndExpenseList(response.data.userIncomeAndExpenses);
            setIncomeAndExpenseTotal(response.data.userTotal.totalBalance);
          }
        } catch (error) {
          setIncomeAndExpenseList([]);
          setIncomeAndExpenseTotal([]);
        }
      };

      fetchData();
    }
  }, [data, reloadData, user]);
  const handleIncome = async (data) => {
    navigate("/detalle-ingresos-egresos", { state: data });
  };

  return (
    <div className={styles.informacionPolitica} id="income">
      <div className={styles.sectionTitle2} id={"box_buttonflexcollum"}>
        <div className={styles.sectionTitle3}>
          <h2 className={styles.sectionTitleH2}>
            Pagos y Cobros con la Mutual
          </h2>
          <IconAnimation />
        </div>
        <div className={styles.buttonsContainer}>
          <button
            type="button"
            id={styles.buttonmrd}
            className={styles.button}
            onClick={() => handleIncome(data)}
          >
            <i className="fa fa-refresh"></i> Ver Pagos <br />y Cobros
            <FaArrowRight className={styles.icon} />
          </button>
        </div>
      </div>
      {!user ? (
        <NotReportViewData
          title="Pagos y Cobros con la Mutual"
          Icon={HiClipboardDocumentList}
        />
      ) : (
        <div className="box_all_ing_eg">
          <div className="display_selec_date">
            <select
              className="select_ig_eg"
              onChange={(e) =>
                setObjIncomeAndExpenses({
                  ...objincomeAndExpenses,
                  incomeAndExpenses: e.target.value,
                })
              }
              value={objincomeAndExpenses.incomeAndExpenses}
            >
              <option>Seleciona un valor</option>
              <option value="Ingresos">Ingresos</option>
              <option value="Egresos">Egresos</option>
            </select>
            <input
              className="select_ig_eg"
              type="date"
              value={objincomeAndExpenses.createAt || ""}
              onChange={(e) =>
                setObjIncomeAndExpenses({
                  ...objincomeAndExpenses,
                  createAt: e.target.value,
                })
              }
            />
            <input
              className="select_ig_eg"
              type="number"
              placeholder="Monto"
              value={objincomeAndExpenses.amount || ""}
              onChange={(e) =>
                setObjIncomeAndExpenses({
                  ...objincomeAndExpenses,
                  amount: e.target.value,
                })
              }
            />
          </div>
          <div>
            <textarea
              className="text_area_ig_eg"
              placeholder="Ingrese una Descripcion del archivo"
              value={objincomeAndExpenses.description || ""}
              onChange={(e) =>
                setObjIncomeAndExpenses({
                  ...objincomeAndExpenses,
                  description: e.target.value,
                })
              }
            ></textarea>
          </div>
          <div className="box_button_ig_eg">
            <button
              className="button_ig_eg"
              type="button"
              onClick={(e) => handleClick(e)}
            >
              Crear
            </button>
            {seeList === false ? (
              <button
                className="button_ig_eg"
                type="button"
                id="botton_ig_eg_two"
                onClick={viewList}
              >
                Ver Mas
              </button>
            ) : (
              <button
                className="button_ig_eg"
                type="button"
                id="botton_ig_eg_two"
                onClick={cancelviewList}
              >
                Ver Menos
              </button>
            )}
          </div>
          {seeList === true ? (
            <>
              <div className="list_reports_ig_eg">
                <div className="scrool_ig_eg">
                  {incomeAndExpenseList.length === 0 ? (
                    <p className="notitemlist">
                      No hay ingresos/egresos disponibles de este mes.
                    </p>
                  ) : (
                    incomeAndExpenseList.map((item, index) => (
                      <div className="reports_ig_eg" key={index}>
                        <div className="width_ig_ig_eg first_three">
                          <p className="ig_eg_p_data">
                            {item.incomeAndExpenses}
                          </p>
                        </div>
                        <div className="width_ig_ig_eg first_three">
                          <p className="ig_eg_p_data">{item.createAt}</p>
                        </div>
                        <div className="width_ig_ig_eg first_three">
                          <p className="ig_eg_p_data">{"$" + item.amount}</p>
                        </div>
                        <div className="width_ig_ig_eg">
                          <p className="ig_eg_p_data">{item.description}</p>
                        </div>
                      </div>
                    ))
                  )}
                </div>
                <div className="total_ig_eg">
                  <div className="ig_eg_total">
                    <p className="ig_eg_p_data">
                      Monto Total: {incomeAndExpenseTotal}
                    </p>
                  </div>
                </div>
              </div>
            </>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default IncomeAndExpenses;
